function SliderClients(container){
	var _this = this;
	this.container = $(container);
	_this.container.flexslider({
		pauseOnHover: true,
		animation: 'slide',
		animationLoop: true,
		itemMargin: 0,
		move: 1,
		useCSS: false,
		controlNav: false,
		directionNav: true,
		startAt: 0,
		slideshow: false,
		slideshowSpeed: 5000,
		start: function(slider) {
			slider.slides.css({height: 'auto', overflow: 'visible'});
			var h = slider.slides.eq(slider.animatingTo).height();
			slider.slides.css({height: h, overflow: 'hidden'});
			slider.slides.siblings('.clone').css({height: h, overflow: 'hidden'});
			slider.slides.eq(slider.currentSlide).css({height: 'auto', overflow: 'visible'});
		},
		before: function(slider) {
			slider.slides.css({height: 'auto', overflow: 'visible'});
			var h = slider.slides.eq(slider.animatingTo).height();
			slider.slides.css({height: h, overflow: 'hidden'});
			slider.slides.siblings('.clone').css({height: h, overflow: 'hidden'});
			slider.slides.eq(slider.animatingTo).css({height: 'auto', overflow: 'visible'});
		}
	});
}

if (typeof define === "function" && define.amd) {
	define('Controls/SliderClients',['flexslider'], function() {
		return SliderClients;
	});
};
